var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-icon",class:_vm.getIconClass(_vm.item),on:{"click":_vm.previewPdf}})
}
var staticRenderFns = []

export { render, staticRenderFns }